<script lang="ts">
  import { app } from '../../lib/app.svelte';
</script>

<footer class="wrap foot">
  <div>
    <b>How to read this page.</b> Solid numbers are votes actually counted, straight from the S.C. Election Commission.
    Anything marked <span class="est-chip" style="vertical-align:0">Est.</span> or drawn in purple is our model’s estimate of the final result, shown with its range of uncertainty — not an official result.
  </div>
  <div class="links">
    <a href={app.href('#/diagnostics')}>How the estimates work</a>
    <span>Times are Eastern.</span>
  </div>
</footer>

<style>
  .foot { margin-top: 56px; padding-top: 22px; padding-bottom: 18px; border-top: 1px solid var(--line); display: flex; gap: 12px 32px; flex-wrap: wrap; justify-content: space-between; font-size: 0.84rem; color: var(--ink-3); }
  .foot > div:first-child { max-width: 720px; }
  .links { display: flex; gap: 16px; align-items: flex-start; }
</style>
